<template>
  <app-form-input-select
    v-model="model"
    item-title="label"
    item-value="path"
    :items="data"
    :label="label"
    multiple
    non-required-mention
    :prepend-icon="icon ?? 'ph:tag'"
    :required="required"
  >
    <template #prepend>
      <p class="text-subtle text-sm">Sélectionnez 1 ou plusieurs catégories</p>
    </template>
  </app-form-input-select>
</template>

<script lang="ts" setup>
const model = defineModel<string | string[] | undefined>({
  default: undefined,
});

defineProps<{
  required?: boolean;
  label?: string;
  icon?: string;
}>();

const { data } = useTagList({
  depth: 0,
  used: true,
});
</script>
